import { useTranslation } from 'react-i18next';

export const DeclineMessage = () => {
  const { t } = useTranslation('pages.enrollment.review');
  return (
    <div className="decline-message overline1">
      <i
        className="ph-thin ph-prohibit"
        aria-hidden="true"
        role="presentation"
      ></i>
      {t('declined')}
    </div>
  );
};
